var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".prefix__cls-3{fill:#107c41}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Excel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix___24",
    "data-name": 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 1H7a1 1 0 00-1 1v5l10 5 4 1.5 4-1.5V7z",
    fill: "#21a366"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-3",
    d: "M6 7.02h10V12H6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 2v5h-8V1h7a1 1 0 011 1z",
    fill: "#33c481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12H6v10a1 1 0 001 1h16a1 1 0 001-1v-5z",
    fill: "#185c37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.83 6H6v14h7.6a1.5 1.5 0 001.4-1.35V7.17A1.18 1.18 0 0013.83 6z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Back_Plate",
    "data-name": "Back Plate",
    className: "prefix__cls-3",
    y: 5,
    width: 14,
    height: 14,
    rx: 1.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.43 16L6 12 3.64 8h1.91l1.3 2.55a4.63 4.63 0 01.24.54 5.77 5.77 0 01.27-.56L8.76 8h1.75l-2.43 4 2.49 4H8.71l-1.5-2.8a2.14 2.14 0 01-.21-.37 1.54 1.54 0 01-.17.36L5.3 16z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__cls-3",
    d: "M16 12h8v5h-8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.4a9314bbbfd03e2d908d9dd511ac240c.svg";
export { ForwardRef as ReactComponent };